import React from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';

const aboutUsContent = [
  {
    imageSrc: '/assets/akyga_biuro.png',
    description: `aboutUs.components.first`,
  },
  {
    imageSrc: '/assets/akyga_bateryjka.png',
    description: `aboutUs.components.second`,
  },
  {
    imageSrc: '/assets/akyga_ladowarka.jpg',
    description: `aboutUs.components.third`,
  },
];

const Bateryjki = () => {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <Box
      paddingY={6}
      sx={{
        backgroundColor: theme.palette.primary.main, // Primary color for the background
        color: 'common.white', // Ensuring text visibility
      }}
    >
      <Helmet>
        <title>{t('aboutUs.pageTitle')}</title>
        <meta name="description" content={aboutUsContent[0].description} />
      </Helmet>
      <Typography
        variant="h4"
        gutterBottom
        sx={{
          fontWeight: 'bold',
          marginBottom: theme.spacing(4),
        }}
      >
        {t('aboutUs.title')}
      </Typography>
      <Grid container spacing={3}>
        {aboutUsContent.map((item, index) => (
          <Grid key={index} item xs={12} sm={6} md={4}>
            <Box
              component="img"
              src={item.imageSrc}
              alt={`About us image ${index + 1}`}
              sx={{
                borderRadius: 2,
                width: '100%',
                height: 'auto',
                boxShadow: theme.shadows[2],
              }}
            />
            <Typography
              variant="body1"
              sx={{
                marginTop: theme.spacing(2),
                fontWeight: 400,
                lineHeight: 1.5,
              }}
            >
              {t(item.description)}
            </Typography>
          </Grid>
        ))}
      </Grid>
      <Box
        marginTop={4}
        display="flex"
        justifyContent="flex-end"
        marginRight={10}
      ></Box>
    </Box>
  );
};

export default Bateryjki;
